import ReactGA from 'react-ga4';
import { ANALYTICS_EVENT_NAMES } from '../constants/analytics-events-config';
import { BUTTON_TITLES } from '../constants/button-titles';
import { getUUID } from './helperUtils';
import apis from '../Services/api-services';
import { APP_VERSION } from '../constants/app-constants';

// Initialize GA4 
export const initGA = () => {
  ReactGA.initialize('G-5PWBKNF9TX'); 
  // ReactGA.initialize('G-LH6SKJCVDH'); // Prod 
};

// Track page views (should be called on route change)
export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

// Track custom events
export const trackGAEvent = ({ category, action, label, value }) => {

  console.log({ category, action, label, value },'GA-LOGS')
  ReactGA.event({
    category, // 'User'
    action,   // 'Clicked Save Property'
    label,    // 'Property ID: 12345'
    value,    // Optional: e.g. any
  });
};

// Set user ID (optional)
export const setUserId = (userId) => {
  ReactGA.set({ user_id: userId });
};

// Common function to send analytics events to backend API
export const sendAnalyticsEventToServer = async (eventName, additionalData = {},uuid='') => {
  try {
    const analyticsData = {
      event_name: eventName,
      source: 'web', 
      version: APP_VERSION, // app version
      unique_id: uuid || getUUID(), // generate unique ID for each event
      logs: JSON.stringify({
        timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent,
        url: window.location.href,
        ...additionalData
      })
    };

    const response = await apis.analytics.sendAnalyticsEvent(analyticsData);
    return response;
  } catch (error) {
    console.error('Analytics API Error:', error);
    return null;
  }
};

export const trackDailyVisit = () => {
  const today = new Date().toISOString().split('T')[0]; 
  const lastTrackedDate = localStorage.getItem('lastTrackedVisitDate');

  if (lastTrackedDate !== today) {
    // Fire the GA event
    trackGAEvent({
      category: 'User',
      action: 'first_visit_day',
      label: `Visited on ${today}`,
      value: 1,
    });

    localStorage.setItem('lastTrackedVisitDate', today);
  }
};

// Helper function to track button clicks with analytics API
// export const trackButtonClick = async (buttonTitle, additionalData = {}) => {
//   // Map button titles to event names
//   const buttonEventMap = {
//     [BUTTON_TITLES.REGENERATE_DESCRIPTION]: ANALYTICS_EVENT_NAMES.BUTTON_REGENERATE_DESCRIPTION,
//     [BUTTON_TITLES.BOOST_SEARCH]: ANALYTICS_EVENT_NAMES.BUTTON_BOOST_SEARCH,
//     [BUTTON_TITLES.VIEW]: ANALYTICS_EVENT_NAMES.BUTTON_VIEW,
//     [BUTTON_TITLES.SHOW_RESULTS]: ANALYTICS_EVENT_NAMES.BUTTON_SHOW_RESULTS,
//     [BUTTON_TITLES.ADD_LISTING]: ANALYTICS_EVENT_NAMES.BUTTON_ADD_LISTING,
//     [BUTTON_TITLES.ONE_CLICK_MARKETING_MAGIC]: ANALYTICS_EVENT_NAMES.BUTTON_ONE_CLICK_MARKETING,
//     [BUTTON_TITLES.VIEW_LEADS]: ANALYTICS_EVENT_NAMES.BUTTON_VIEW_LEADS,
//     [BUTTON_TITLES.VIEW_PROFILE]: ANALYTICS_EVENT_NAMES.BUTTON_VIEW_PROFILE,
//     [BUTTON_TITLES.VIEW_ALL_TRANSLATED]: ANALYTICS_EVENT_NAMES.BUTTON_VIEW_ALL,
//     [BUTTON_TITLES.MESSAGE]: ANALYTICS_EVENT_NAMES.BUTTON_MESSAGE,
//     [BUTTON_TITLES.EDIT_PROFILE]: ANALYTICS_EVENT_NAMES.BUTTON_EDIT,
//     [BUTTON_TITLES.SHARE_PROFILE]: ANALYTICS_EVENT_NAMES.BUTTON_SHARE,
//     [BUTTON_TITLES.BACK]: ANALYTICS_EVENT_NAMES.BUTTON_BACK,
//     [BUTTON_TITLES.SEARCH]: ANALYTICS_EVENT_NAMES.BUTTON_SEARCH,
//     [BUTTON_TITLES.ADD_LISTING_SEARCH]: ANALYTICS_EVENT_NAMES.BUTTON_ADD_LISTING,
//     [BUTTON_TITLES.SUBMIT]: ANALYTICS_EVENT_NAMES.BUTTON_SUBMIT,
//     [BUTTON_TITLES.CLOSE]: ANALYTICS_EVENT_NAMES.BUTTON_CLOSE,
//     [BUTTON_TITLES.LOADING]: ANALYTICS_EVENT_NAMES.BUTTON_LOADING,
//     [BUTTON_TITLES.FIND_AGENT]: ANALYTICS_EVENT_NAMES.BUTTON_FIND_AGENT,
//     [BUTTON_TITLES.VIEW_ALL]: ANALYTICS_EVENT_NAMES.BUTTON_VIEW_ALL,
//     [BUTTON_TITLES.SETUP_SHOP]: ANALYTICS_EVENT_NAMES.BUTTON_SETUP_SHOP,
//     [BUTTON_TITLES.SETUP_SHOP_FREE]: ANALYTICS_EVENT_NAMES.BUTTON_SETUP_SHOP,
//     [BUTTON_TITLES.BOOST]: ANALYTICS_EVENT_NAMES.BUTTON_BOOST,
//     [BUTTON_TITLES.CLEAR_ALL]: ANALYTICS_EVENT_NAMES.BUTTON_CLEAR,
//     [BUTTON_TITLES.APPLY]: ANALYTICS_EVENT_NAMES.BUTTON_APPLY,
//     [BUTTON_TITLES.ADD_A_PROPERTY]: ANALYTICS_EVENT_NAMES.BUTTON_ADD_PROPERTY,
//     [BUTTON_TITLES.FIND_PROPERTY]: ANALYTICS_EVENT_NAMES.BUTTON_FIND_PROPERTY,
//     [BUTTON_TITLES.GO_TO_MESSAGES]: ANALYTICS_EVENT_NAMES.BUTTON_GO_TO_MESSAGES,
//     [BUTTON_TITLES.MARK_AS_CLOSED]: ANALYTICS_EVENT_NAMES.BUTTON_MARK_AS_CLOSED,
//     [BUTTON_TITLES.VERIFY_NOW]: ANALYTICS_EVENT_NAMES.BUTTON_VERIFY_NOW,
//     [BUTTON_TITLES.RE_VERIFY_NOW]: ANALYTICS_EVENT_NAMES.BUTTON_RE_VERIFY_NOW,
//     [BUTTON_TITLES.UNLOCK_TO_CHAT]: ANALYTICS_EVENT_NAMES.BUTTON_MESSAGE,
//   };

//   const eventName = buttonEventMap[buttonTitle] || ANALYTICS_EVENT_NAMES.BUTTON_CLICK;
  
//   return await sendAnalyticsEventToServer(eventName, {
//     button_title: buttonTitle,
//     ...additionalData
//   });
// };

